module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/mv_04-79fc1ccade78691413dac5d0120b3b1e.jpg";